import { Drawer, Grid, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core"
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { AppDispatch } from "../../redux/store";
import { DATA_NOT_FOUND } from "../../constants/globalConstants";
import {  SelectBox, Text } from "sunrise-ui";
import FilterComponent from "../../components/helperComponents/FilterComponent";
import { HeadLines } from "../Dashboard/Dashboard";
import NoDataScreen from "../../utilities/NoDataScreenSmall";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import BillDrawer from "./BillDrawer";
import ExpenseReportBar from "./ExpenseReportBar";
import BillReportBar from "./BillReportBar";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import {
    getOverallExpenses, getOverallExpensesInventory, getOverallExpensesSubContractor, getOverallExpensesMachineRental,
    getOverallExpensesMachineryRepair, getOverallExpensesMiscellaneous, getOverallExpensesByProjectTypeForTable,
    getExpensesForProjectInventory, getExpensesForProjectSubContractor, getExpensesForProjectMachineRental,
    getExpensesForProjectMachineryRepair, getExpensesForProjectMiscellaneous, getBillData,
} from "../../redux/reducers/billReducer";
import toaster from "../../utilities/toaster";
import Loader from "../../utilities/Loader";


const useStylesForTable = makeStyles({
    table: {
        // minWidth: 650,
        // width: "max-content",
        width: "100%",
        flexGrow: 1,
    },
});
const ExpenseReport = () => {
    const dispatch = useDispatch<AppDispatch>();
    const tableClasses = useStylesForTable();
    const [value, setValue] = useState({ from: "", to: "" });
    const [drawerToggle, setDrawerToggle] = useState(false);
    const [drawerData, setDrawerData] = useState(null);
    const [projectName, setProjectName] = useState("");
    const [projectId, setProjectId] = useState("");
    const [loading, setLoading] = useState(false);

    const allProjectData = useSelector(
        (state: any) => state.PROJECT.allProjectData
    );
    const profileData = useSelector((state: any) => state.PROFILE.profileDetails);
    const billsData = useSelector((state: any) => state.BILLS.billsData);
    //------for overall expense-----------------------------------------
    const overallExpenses = useSelector((state: any) => state.BILLS.overallExpenses);
    const overallInventory = useSelector((state: any) => state.BILLS.overallExpensesInventory);
    const overallSubContractor = useSelector((state: any) => state.BILLS.overallExpensesSubContractor);
    const overallMachineRental = useSelector((state: any) => state.BILLS.overallExpensesMachineRental);
    const overallMachineryRepair = useSelector((state: any) => state.BILLS.overallExpensesMachineryRepair);
    const overallMiscellaneous = useSelector((state: any) => state.BILLS.overallExpensesMiscellaneous);
    //-------------------for overall expenses of selected project----------------------------
    const overallProjectExpenses = useSelector((state: any) => state.BILLS.overallExpensesByProjectTypeForTable);
    //----------------------for project and bill wise (Table)---------------------------------
    const ProjectInventory = useSelector((state: any) => state.BILLS.expensesForProjectInventory);
    const ProjectSubContractor = useSelector((state: any) => state.BILLS.expensesForProjectSubContractor);
    const ProjectMachineRental = useSelector((state: any) => state.BILLS.expensesForProjectMachineRental);
    const ProjectMachineryRepair = useSelector((state: any) => state.BILLS.expensesForProjectMachineryRepair);
    const ProjectMiscellaneous = useSelector((state: any) => state.BILLS.expensesForProjectMiscellaneous);
    const handleFilterDate = () => { 
        if(!projectId){
            toaster("warning", "select project Id before selecting date")
        }
     if(projectId && value.to && value.from){
        setLoading(true)
        dispatch(
            getOverallExpensesByProjectTypeForTable({
                endPoint: `manage-bill/expense-report-by-project?projectId=${projectId}&to=${value.to}&from=${value.from}`
            })
        );
        dispatch(
            getExpensesForProjectInventory({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=inventory&projectId=${projectId}&to=${value.to}&from=${value.from}`
            })
        );
        dispatch(
            getExpensesForProjectSubContractor({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=sub-contractor&projectId=${projectId}&to=${value.to}&from=${value.from}`
            })
        );
        dispatch(
            getExpensesForProjectMachineRental({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=machine-rental&projectId=${projectId}&to=${value.to}&from=${value.from}`
            })
        );
        dispatch(
            getExpensesForProjectMachineryRepair({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=machinery-repair&projectId=${projectId}&to=${value.to}&from=${value.from}`
            })
        );
        dispatch(
            getExpensesForProjectMiscellaneous({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=miscellaneous&projectId=${projectId}&to=${value.to}&from=${value.from}`
            })
        ).then(()=>setLoading(false));
     }
    }

    const resetToAll = () => { 
        setValue({ from: "", to: "" });
        setLoading(true);
        dispatch(
            getOverallExpensesByProjectTypeForTable({
                endPoint: `manage-bill/expense-report-by-project?projectId=${projectId}`
            })
        );
        dispatch(
            getExpensesForProjectInventory({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=inventory&&projectId=${projectId}`
            })
        );
        dispatch(
            getExpensesForProjectSubContractor({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=sub-contractor&&projectId=${projectId}`
            })
        );
        dispatch(
            getExpensesForProjectMachineRental({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=machine-rental&&projectId=${projectId}`
            })
        );
        dispatch(
            getExpensesForProjectMachineryRepair({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=machinery-repair&&projectId=${projectId}`
            })
        );
        dispatch(
            getExpensesForProjectMiscellaneous({
                endPoint: `manage-bill/expense-report-by-type-and-project?billType=miscellaneous&&projectId=${projectId}`
            })
        ).then(()=>setLoading(false));
    }

    const displayBillData = () => {
        setDrawerData(billsData);
        setDrawerToggle(true);
    }

    const changeReset = () => { };
    //-----Rs. to Lacs conversion----
    const numToLacs = (value: any) => {
        let val = Math.abs(value)
        if (val >= 100000) {
            val = +(val / 100000).toFixed(2);
        }
        else {
            val = +(val / 100000).toFixed(2);
        }
        return val;
    }

    useEffect(() => {
        if (profileData) {
            dispatch(
                getAllProjectData({
                    endPoint: `project/get-all-projects`,
                })
            );
        }
    }, [dispatch, profileData])

    const projectsData: [] =
        allProjectData &&
        allProjectData?.map((item: any) => {
            return item?.projectName;
        });

    useEffect(() => {
        dispatch(
            getOverallExpenses({
                endPoint: `manage-bill/expense-report`,
            })
        );
        dispatch(
            getOverallExpensesInventory({
                endPoint: `manage-bill/expense-report-by-type?billType=inventory`,
            })
        );
        dispatch(
            getOverallExpensesSubContractor({
                endPoint: `manage-bill/expense-report-by-type?billType=sub-contractor`,
            })
        );
        dispatch(
            getOverallExpensesMachineRental({
                endPoint: `manage-bill/expense-report-by-type?billType=machine-rental`,
            })
        );
        dispatch(
            getOverallExpensesMachineryRepair({
                endPoint: `manage-bill/expense-report-by-type?billType=machinery-repair`,
            })
        );
        dispatch(
            getOverallExpensesMiscellaneous({
                endPoint: `manage-bill/expense-report-by-type?billType=miscellaneous`,
            })
        );
    }, [dispatch]);

    //--------------Fetching projectwise details for table------------
    useEffect(() => {
        if (projectId !== '') {
            setLoading(true)
            dispatch(
                getOverallExpensesByProjectTypeForTable({
                    endPoint: `manage-bill/expense-report-by-project?projectId=${projectId}`
                })
            );
            dispatch(
                getExpensesForProjectInventory({
                    endPoint: `manage-bill/expense-report-by-type-and-project?billType=inventory&&projectId=${projectId}`
                })
            );
            dispatch(
                getExpensesForProjectSubContractor({
                    endPoint: `manage-bill/expense-report-by-type-and-project?billType=sub-contractor&&projectId=${projectId}`
                })
            );
            dispatch(
                getExpensesForProjectMachineRental({
                    endPoint: `manage-bill/expense-report-by-type-and-project?billType=machine-rental&&projectId=${projectId}`
                })
            );
            dispatch(
                getExpensesForProjectMachineryRepair({
                    endPoint: `manage-bill/expense-report-by-type-and-project?billType=machinery-repair&&projectId=${projectId}`
                })
            );
            dispatch(
                getExpensesForProjectMiscellaneous({
                    endPoint: `manage-bill/expense-report-by-type-and-project?billType=miscellaneous&&projectId=${projectId}`
                })
            ).then(()=>setLoading(false));
        }
    }, [dispatch, projectId]);

    //-------for recently received bills------
    useEffect(() => {
        if (projectId !== '') {
            dispatch(
                getBillData({
                    endPoint: `manage-bill/get-bills-by-ac&ad?projectId=${projectId}&userId=${profileData?.data?._id}`,
                })
            );
        }
    }, [dispatch, profileData, projectId]);

    const tableData = [
        {
            description: 'Overall',
            pending: { value: overallProjectExpenses?.pending, number: overallProjectExpenses?.pendingCount },
            approved: { value: overallProjectExpenses?.approve, number: overallProjectExpenses?.approveCount },
            rejected: { value: overallProjectExpenses?.reject, number: overallProjectExpenses?.rejectCount }
        },
        {
            description: 'Inventory',
            pending: { value: ProjectInventory?.pending, number: ProjectInventory?.pendingCount },
            approved: { value: ProjectInventory?.approve, number: ProjectInventory?.approveCount },
            rejected: { value: ProjectInventory?.reject, number: ProjectInventory?.rejectCount }
        },
        {
            description: 'Machinery Rental',
            pending: { value: ProjectMachineRental?.pending, number: ProjectMachineRental?.pendingCount },
            approved: { value: ProjectMachineRental?.approve, number: ProjectMachineRental?.approveCount },
            rejected: { value: ProjectMachineRental?.reject, number: ProjectMachineRental?.rejectCount }
        },
        {
            description: 'Machinery Repair',
            pending: { value: ProjectMachineryRepair?.pending ? ProjectMachineryRepair?.pending : 0, number: ProjectMachineryRepair?.pendingCount ? ProjectMachineryRepair?.pendingCount : 0 },
            approved: { value: ProjectMachineryRepair?.approve, number: ProjectMachineryRepair?.approveCount },
            rejected: { value: ProjectMachineryRepair?.reject, number: ProjectMachineryRepair?.rejectCount }
        },
        {
            description: 'Sub-contractor',
            pending: { value: ProjectSubContractor?.pending, number: ProjectSubContractor?.pendingCount },
            approved: { value: ProjectSubContractor?.approve, number: ProjectSubContractor?.approveCount },
            rejected: { value: ProjectSubContractor?.reject, number: ProjectSubContractor?.rejectCount }
        },
        {
            description: 'Miscellaneous',
            pending: { value: ProjectMiscellaneous?.pending, number: ProjectMiscellaneous?.pendingCount },
            approved: { value: ProjectMiscellaneous?.approve, number: ProjectMiscellaneous?.approveCount },
            rejected: { value: ProjectMiscellaneous?.reject, number: ProjectMiscellaneous?.rejectCount }
        },
    ]
    return (
      <Grid spacing={2}>
        <Grid item xs={12}>
          <Text
            type="normal"
            fonts="normal"
            fontSize={18}
            className="mb0 mt1 heading"
          >
            <span className="fw500">Total Expense (Lakhs)</span>
          </Text>
        </Grid>
        <Grid className="flex_start mt0">
          <div className="headline_slider">
            <div className="white-space-nw">
              <HeadLines
                label="Approved"
                icon={"approved"}
                value={numToLacs(overallExpenses?.approve)}
                fontSize={18}
              />
            </div>
            <div className="white-space-nw">
              <HeadLines
                label="Inventory"
                icon={"totalProjectIcon"}
                value={numToLacs(overallInventory?.approve)}
                fontSize={18}
              />
            </div>
            <div className="white-space-nw">
              <HeadLines
                label="Sub-Contractor"
                icon={"subContractor"}
                value={numToLacs(overallSubContractor?.approve)}
                fontSize={18}
              />
            </div>
            <div className="white-space-nw">
              <HeadLines
                label="Machinery Rental"
                icon={"rentalMachine"}
                value={numToLacs(overallMachineRental?.approve)}
                fontSize={18}
              />
            </div>
            <div className="white-space-nw">
              <HeadLines
                label="Machinery Repair"
                icon={"repairMachinery"}
                value={numToLacs(overallMachineryRepair?.approve)}
                fontSize={18}
              />
            </div>
            <div className="white-space-nw">
              <HeadLines
                label="Miscellaneous"
                icon={"miscellaneous"}
                value={numToLacs(overallMiscellaneous?.approve)}
                fontSize={18}
              />
            </div>
          </div>
        </Grid>
        <Grid container className="no_flex_wrap">
          <Grid
            container
            xs={7}
            className="d-flex bg--white box--shadow p1 mt mr-1"
          >
            <Grid xs={6}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb0 mt0"
              >
                <span className="fw500">Select Project</span>
              </Text>
              {/* ------------select project--------- */}
              <SelectBox
                className="select_box"
                data={projectsData ? projectsData : DATA_NOT_FOUND}
                placeHolder="Select Project"
                borderColor={"primary"}
                defaultValue={projectName}
                changeReset={changeReset}
                onChange={(e: any) => {
                  setProjectName(e.target.value);
                  const index = projectsData
                    ?.map((item: any) => item)
                    .indexOf(e.target.value);
                  setProjectId(allProjectData && allProjectData[index]?._id);
                }}
              />
            </Grid>
            <Grid
              item
              className={"mt2 ml-1"}
              direction="row"
              alignItems="center"
            >
              <div className="filter_box_ml mt2">
                <FilterComponent
                  handleFilterDate={handleFilterDate}
                  setValue={setValue}
                  value={value}
                  resetAll={resetToAll}
                />
              </div>
            </Grid>
            {loading ? (
              <div className="loader">
                <Loader
                color="#5f67e0"
                loading={loading}
                size={10}
                height="25vh"
              />
              </div>
            ) : (
              <Grid xs={12}>
                <TableContainer>
                  <Grid className="table_container fixed_header">
                    {projectId !== "" && tableData?.length > 0 ? (
                      <Table
                        className={tableClasses.table}
                        aria-label="simple table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell
                              className="f16 fw500"
                              colSpan={2}
                              align="center"
                            >
                              Approved
                            </TableCell>
                            <TableCell
                              className="f16 fw500"
                              colSpan={2}
                              align="center"
                            >
                              Rejected
                            </TableCell>
                            <TableCell
                              className="f16 fw500"
                              colSpan={2}
                              align="center"
                            >
                              Pending
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className="f16 fw500" align="left">
                              Bill Type
                            </TableCell>
                            <TableCell className="f16 fw500" align="left">
                              Value(Lakhs)
                            </TableCell>
                            <TableCell className="f16 fw500" align="left">
                              Numbers
                            </TableCell>
                            <TableCell className="f16 fw500" align="left">
                              Value(Lakhs)
                            </TableCell>
                            <TableCell className="f16 fw500" align="left">
                              Numbers
                            </TableCell>
                            <TableCell className="f16 fw500" align="left">
                              Value(Lakhs)
                            </TableCell>
                            <TableCell className="f16 fw500" align="left">
                              Numbers
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tableData.map((row: any, index: number) => (
                            <TableRow key={index}>
                              <TableCell
                                component="th"
                                scope="row"
                                className="f14 fw500 capitalize"
                              >
                                {row?.description}
                              </TableCell>
                              <TableCell
                                className="f14 fw400 capitalize"
                                align="left"
                              >
                                {numToLacs(+row?.approved?.value)}
                              </TableCell>
                              <TableCell className="f14 fw400" align="left">
                                {row?.approved?.number}
                              </TableCell>
                              <TableCell className="f14 fw400" align="left">
                                {numToLacs(+row?.rejected?.value)}
                              </TableCell>
                              <TableCell className="f14 fw400" align="left">
                                {row?.rejected?.number}
                              </TableCell>
                              <TableCell className="f14 fw400" align="left">
                                {numToLacs(+row?.pending?.value)}
                              </TableCell>
                              <TableCell className="f14 fw400" align="left">
                                {row?.pending?.number}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                        )
                      </Table>
                    ) : (
                      <Grid container>
                        <Grid item xs={12}>
                          <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="fw400 t-center"
                          >
                            <SelectOptionMsg
                              text={`Select project to view Project information`}
                            />
                          </Text>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </TableContainer>
              </Grid>
            )}
          </Grid>

          <Grid container xs={5} className="d-flex bg--white box--shadow p1 mt">
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb0 mt0"
              >
                <span className="fw500">Recently Received Bills</span>
              </Text>
            </Grid>
            {billsData.length > 0 && projectId !== "" ? (
              <Grid
                item
                xs={12}
                className="expense_recent-bill-text p1 mt bills-gap"
              >
                <Grid className="d-flex v-center bills capitalize ">
                  <Grid
                    className="icon_container client_icon mr"
                    style={{ color: "#A15000" }}
                  >
                    1
                  </Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb0 mt0 fw400"
                  >
                    <span className="expense_recent-bill-text">
                      {" "}
                      {billsData[0]?.projectAndUserDetails?.userName} raised one{" "}
                      {billsData[0]?.billType} bill in {projectName} Project
                      with ref no.
                      <Text
                        type="link"
                        fonts="normal"
                        className="mb0 mt0 capitalize pointer"
                        onTextClick={() => {
                          displayBillData();
                          setDrawerData(billsData[0]);
                        }}
                      >
                        {billsData[0]?.billReferenceNumber}
                      </Text>
                    </span>
                  </Text>
                </Grid>
                <Grid className="d-flex v-center bills capitalize">
                  <Grid
                    className="icon_container client_icon mr"
                    style={{ color: "#A15000" }}
                  >
                    2
                  </Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb0 mt0 fw400"
                  >
                    <span className="expense_recent-bill-text">
                      {" "}
                      {billsData[1]?.projectAndUserDetails?.userName} raised one{" "}
                      {billsData[1]?.billType} bill in {projectName} Project
                      with ref no.
                      <Text
                        type="link"
                        fonts="normal"
                        className="mb0 mt0 capitalize pointer"
                        onTextClick={() => {
                          displayBillData();
                          setDrawerData(billsData[1]);
                        }}
                      >
                        {billsData[1]?.billReferenceNumber}
                      </Text>
                    </span>
                  </Text>
                </Grid>
                <Grid className="d-flex v-center bills capitalize">
                  <Grid
                    className="icon_container client_icon mr"
                    style={{ color: "#A15000" }}
                  >
                    3
                  </Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb0 mt0 fw400"
                  >
                    <span className="expense_recent-bill-text">
                      {billsData[2]?.projectAndUserDetails?.userName} raised one{" "}
                      {billsData[2]?.billType} bill in {projectName} Project
                      with ref no.
                      <Text
                        type="link"
                        fonts="normal"
                        className="mb0 mt0 capitalize pointer"
                        onTextClick={() => {
                          displayBillData();
                          setDrawerData(billsData[2]);
                        }}
                      >
                        {billsData[2]?.billReferenceNumber}
                      </Text>
                    </span>
                  </Text>
                </Grid>
                <Grid className="d-flex v-center bills capitalize">
                  <Grid
                    className="icon_container client_icon mr"
                    style={{ color: "#A15000" }}
                  >
                    4
                  </Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb0 mt0 fw400"
                  >
                    <span className="expense_recent-bill-text">
                      {" "}
                      {billsData[3]?.projectAndUserDetails?.userName} raised one{" "}
                      {billsData[3]?.billType} bill in {projectName} Project
                      with ref no.
                      <Text
                        type="link"
                        fonts="normal"
                        className="mb0 mt0 capitalize pointer"
                        onTextClick={() => {
                          displayBillData();
                          setDrawerData(billsData[3]);
                        }}
                      >
                        {billsData[3]?.billReferenceNumber}
                      </Text>
                    </span>
                  </Text>
                </Grid>
                <Grid className="d-flex v-center bills capitalize">
                  <Grid
                    className="icon_container client_icon mr"
                    style={{ color: "#A15000" }}
                  >
                    5
                  </Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb0 mt0 fw400"
                  >
                    <span className="expense_recent-bill-text">
                      {" "}
                      {billsData[4]?.projectAndUserDetails?.userName} raised one{" "}
                      {billsData[4]?.billType} bill in {projectName} Project
                      with ref no.
                      <Text
                        type="link"
                        fonts="normal"
                        className="mb0 mt0 capitalize pointer"
                        onTextClick={() => {
                          displayBillData();
                          setDrawerData(billsData[4]);
                        }}
                      >
                        {billsData[4]?.billReferenceNumber}
                      </Text>
                    </span>
                  </Text>
                </Grid>
              </Grid>
            ) : (
              <NoDataScreen text={"No Data Available."} />
            )}
          </Grid>
        </Grid>
        <ExpenseReportBar />
        <BillReportBar />
        {
          <Drawer
            anchor={"right"}
            open={drawerToggle}
            onClose={() => setDrawerToggle(false)}
          >
            <BillDrawer
              drawerData={drawerData}
              toggleDrawer={setDrawerToggle}
            />
          </Drawer>
        }
      </Grid>
    );
}

export default ExpenseReport;